import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AccountElementService } from 'app/core/services/account-element.service';
import { RefreshElementValueService } from 'app/core/services/refresh-element-value/refresh-element-value.service';

@Component({
  selector: 'dialog-delete-element-batch',
  templateUrl: './dialog-delete-element-batch.component.html',
  styleUrls: ['./dialog-delete-element-batch.component.scss']
})
export class DialogDeleteElementBatchComponent implements OnInit {
  isLoading: boolean = false;
  
  constructor(public dialogRef: MatDialogRef<DialogDeleteElementBatchComponent>,@Inject(MAT_DIALOG_DATA) public data: any,
              private accountElementService: AccountElementService, private refreshElementValue: RefreshElementValueService) { }

  ngOnInit(): void {
    
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  deleteSelectedElement() {
    this.isLoading = true;
    this.accountElementService.deleteElementValue(this.data.selectedIds).subscribe({
      next: (res) => {
        this.refreshElementValue.emitRefresh(this.data.selectedIds);
        Promise.resolve().then(() => {
          this.isLoading = false;
          this.dialogRef.close();
        });
      },
      error: (err) => {
        this.isLoading = true;
        console.error('Error deleting element:', err);
        alert('Failed to delete selected element.');
      },
    });
  }
}
